import { clasolSuiteApi } from '../axiosConfig'
import { buildListParams, withSuiteAdminCode } from '../apiHelpers'

export const getRoles = async (params) => {
  const { data } = await clasolSuiteApi.get('/roles', {
    params: buildListParams(params),
    ...withSuiteAdminCode(),
  })
  return data
}

export const getRole = async (id) => {
  const { data } = await clasolSuiteApi.get(`/roles/${encodeURIComponent(id)}`, withSuiteAdminCode())
  return data
}

export const createRole = async (role) => {
  const { data } = await clasolSuiteApi.post('/roles', role, withSuiteAdminCode())
  return data
}

export const updateRole = async (id, role) => {
  const { data } = await clasolSuiteApi.patch(`/roles/${encodeURIComponent(id)}`, role, withSuiteAdminCode())
  return data
}

export const deleteRole = async (id) => {
  await clasolSuiteApi.delete(`/roles/${encodeURIComponent(id)}`, withSuiteAdminCode())
}
